import React from "react"
import Flex from "@irati/ui/src/Flex"
import Spacing from "@irati/ui/src/Spacing"
import styled, {css} from "styled-components"
import {Body, H1, H4} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import {useTheme} from "@irati/ui/src/global/useTheme"
import home_and_electronics from "@irati/ui/images/home_and_electronics.svg"
import cycle_to_work from "@irati/ui/images/cycle_to_work.svg"
import {useStoreContext} from "../../context/StoreContext"

export const Header = () => {
  const theme = useTheme()
  const {isHE} = useStoreContext()

  return (
    <Flex gap={3} alignItems="center" marginTop={1.5}>
      <Spacing hideOnMobile>
        <Logo src={isHE ? home_and_electronics : cycle_to_work} alt={isHE ? "Home and Electronics logo" : "Cycle to Work logo"} />
      </Spacing>
      <div>
        <TitleContainer>
          <H1 color={theme.colors.primary2} marginBottom={1} marginRight={2}>
            {isHE ? (
              <FormattedMessage id="platform.payrollpay.store.landing.he.title" />
            ) : (
              <FormattedMessage id="platform.payrollpay.store.landing.c2w.title" />
            )}
          </H1>
          {!isHE && (
            <SaveUpTo>
              <FormattedMessage id="platform.payrollpay.store.landing.c2w.saveUpTo" />
            </SaveUpTo>
          )}
        </TitleContainer>
        <Body small maxWidth="unset" color={theme.colors.primary2}>
          {isHE ? (
            <FormattedMessage id="platform.payrollpay.store.landing.he.description" />
          ) : (
            <FormattedMessage id="platform.payrollpay.store.landing.c2w.description" />
          )}
        </Body>
      </div>
    </Flex>
  )
}

const Logo = styled.img`
  height: 100%;
  width: auto;
  padding: 20px;
  border-radius: 14px;
  box-shadow: ${({theme}) => theme.shadows.low};
`

const TitleContainer = styled.div`
  ${({theme}) => css`
    display: flex;
    flex-direction: column;
    ${theme.mediaQueries.minWidthMedia.desktop`
      flex-direction: row;
    `}
  `}
`

const SaveUpTo = styled(H4)`
  ${({theme}) => css`
    padding: ${theme.spacing.oneAndHalf};
    background-color: ${theme.colors.primary1_50};
    border-radius: ${theme.border.radius.medium};
    width: fit-content;
  `}
`
